import React, { useState } from 'react';
import { ArrowRight, NewTeam } from 'icons';
import { Link } from 'core/routing';
import { MenuItem, Box, SvgIcon } from 'components';

export type NewTeamWorkSpaceProps = {
  hoverIcon?: React.ReactNode;
  allowHoverIcon?: boolean;
};
export const NewTeamWorkSpace = ({
  allowHoverIcon,
  hoverIcon = <ArrowRight />,
}: NewTeamWorkSpaceProps) => {
  const [isHover, setIsHover] = useState(false);

  return (
    <Link name='home.newInitiative'>
      <MenuItem
        onMouseEnter={() => {
          setIsHover(true);
        }}
        onMouseLeave={() => {
          setIsHover(false);
        }}
        className='flex justify-between'
      >
        <div className='flex'>
          <SvgIcon size='medium' icon={<NewTeam />} />
          <Box ml={2}>New Team Workspace</Box>
        </div>
        {isHover && allowHoverIcon && <div className='mr-2'>{hoverIcon}</div>}
      </MenuItem>
    </Link>
  );
};
